export default __webpack_public_path__ + "static/media/projectImagePlaceholder.25b04701.svg";